import { fetchFlask } from '../../utils/fetchFlask';

export const FECHAMENTO_PROJETOS_API = 'listarProjetosDRE';
export const FECHAMENTO_TOTAL_API = 'fechamento/total';
export const FECHAMENTO_UGS_API = 'fechamento/ugs';
export const FECHAMENTO_UCS_API = 'fechamento/ucs';
export const FECHAMENTO_CUSTOS_API = 'fechamento/custos';

export const UCS_PAGE_SIZE_OPTIONS = [25, 50, 100];

export const UCS_INITIAL_FILTERS = {
    carteira: 'PRINCIPAL',
    busca: '',
    distribuidora: '',
    categoria: '',
    so_divergentes: false
};

export const UCS_INITIAL_SORT = { ordenar: 'cc', direcao: 'asc' };

export const CARTEIRA_UC_OPTIONS = [
    { value: 'PRINCIPAL', label: 'Principal' },
    { value: 'PPA', label: 'PPA' },
    { value: 'SALDO', label: 'UC Saldo' },
    { value: 'TODAS', label: 'Todas' }
];

export const CARTEIRA_CUSTO_OPTIONS = [
    { value: 'TODAS', label: 'Todas' },
    { value: 'PRINCIPAL', label: 'Principal' },
    { value: 'PPA', label: 'PPA' }
];

export const DISTRIBUIDORA_OPTIONS = ['NEOENERGIA PE', 'COSERN'];

export const CATEGORIA_UC_OPTIONS = ['B1', 'B2', 'B3C', 'B3I', 'B3CO', 'AT'];

export const CLASSES_CUSTO = [
    { value: 'ajuste', label: 'Ajuste de fechamento' },
    { value: 'despesa', label: 'Despesas' }
];

// Erros chegam como { status: 'error', message }; qualquer outra coisa sem status 'success' também é erro.
const ensureSuccess = (response, fallbackMessage) => {
    if (response?.status === 'success') return response;

    throw new Error(response?.message || fallbackMessage);
};

export const fetchFechamentoMeses = async () => {
    const response = ensureSuccess(await fetchFlask(FECHAMENTO_PROJETOS_API), 'Não foi possível carregar os meses.');
    const porMes = new Map();

    // A lista do DRE traz o projeto principal e o PPA de cada mês como linhas separadas.
    (response.message ?? []).forEach(({ codigo, nome, mes }) => {
        const item = porMes.get(mes) ?? { mes };
        if (/PPA$/.test(nome)) Object.assign(item, { ppa: codigo, nome_ppa: nome });
        else Object.assign(item, { principal: codigo, nome_principal: nome });
        porMes.set(mes, item);
    });

    return [...porMes.values()].map((item) => ({ ...item, nome: item.nome_principal ?? item.nome_ppa }));
};

export const fetchFechamentoTotal = async (mes) => {
    const response = ensureSuccess(
        await fetchFlask(FECHAMENTO_TOTAL_API, JSON.stringify({ mes })),
        'Não foi possível carregar o total do fechamento.'
    );

    return response.message;
};

export const fetchFechamentoUgs = async (mes) => {
    const response = ensureSuccess(
        await fetchFlask(FECHAMENTO_UGS_API, JSON.stringify({ mes })),
        'Não foi possível carregar as UGs.'
    );

    return response.message ?? [];
};

export const fetchFechamentoCustos = async (mes) => {
    const response = ensureSuccess(
        await fetchFlask(FECHAMENTO_CUSTOS_API, JSON.stringify({ mes })),
        'Não foi possível carregar os custos.'
    );

    return response.message ?? [];
};

// Esta rota responde em `data` (não em `message`), como as listas paginadas do CRM.
export const fetchFechamentoUcsPage = async ({ mes, filters, sort, page, pageSize }) => {
    const response = ensureSuccess(
        await fetchFlask(FECHAMENTO_UCS_API, JSON.stringify({
            mes,
            carteira: filters.carteira,
            busca: filters.busca,
            distribuidora: filters.distribuidora,
            categoria: filters.categoria,
            so_divergentes: filters.so_divergentes,
            page,
            page_size: pageSize,
            ordenar: sort.ordenar,
            direcao: sort.direcao
        })),
        'Não foi possível carregar as UCs.'
    );

    return {
        items: response.data?.items ?? [],
        total: response.data?.total ?? 0,
        page: response.data?.page ?? page,
        totais: response.data?.totais ?? null
    };
};

// Mês padrão: o último já encerrado, isto é, o mais recente anterior ao mês corrente
// (a lista vem do mais novo para o mais antigo). Sem nenhum, fica o mais antigo da lista.
export const getDefaultMes = (meses, today = new Date()) => {
    const mesAtual = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
    const encerrado = meses.find((item) => item.mes < mesAtual);

    return (encerrado ?? meses[meses.length - 1])?.mes ?? '';
};
